import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ComplaintsProvider } from '../../providers/complaints/complaints';
import { ComplaintTabsPage } from '../complaint-tabs/complaint-tabs';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-mark-close-modal',
  templateUrl: 'mark-close-modal.html',
})
export class MarkCloseModalPage {

  rating = "0";
  review = "";
  complaint: any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private viewCtrl: ViewController,
    private complaintsProvider: ComplaintsProvider,
    private util: UtilService) {
      this.complaint = this.navParams.get('data');
      this.navCtrl = this.navParams.get('parentPageNav');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  starClicked(num: number){
    num++;
    this.rating = num.toString();
    console.log(this.rating);
  }

  nonStarClicked(num: number){
    let temp = +this.rating;
    temp = temp + num + 1;
    this.rating = temp.toString();
    console.log(this.rating);
  }

  getRating(rating: string){
  	return Array(+rating);
  }

  getNonRating(rating: string){
    return Array(5 - (+rating));
  }

  onMarkClose(){
    this.complaint.resident_remarks = this.review;
    this.complaint.rating = this.rating;
    this.complaint.status = "Closed";
    this.complaintsProvider.updateComplaint(this.complaint).then(res => {
      if(res.status == "success"){
        this.dismiss();
        this.navCtrl.push(
          ComplaintTabsPage,
          {index: 1}
        ).then(() =>  {
          this.util.clearNavStack(this.navCtrl);
        });
      } else {
        this.dismiss();
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MarkCloseModalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/mark-close-modal/mark-close-modal.ts